module.exports = __webpack_public_path__ + "img/20190524164334QQ截图20190524163321.e8ffb9f1.png";